<template>
  <div class="auth-buttons">
    <router-link
      :to="signupUrl"
      class="auth-link"
      data-testid="sign-up"
    >
      {{ $t('nav.signup') }}
    </router-link>
    <router-link
      :to="loginUrl"
      class="auth-link"
      data-testid="sign-in"
    >
      {{ $t('nav.login') }}
    </router-link>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useMcp } from '@/composables/useMcp'

const { getMcpFlowId } = useMcp()

/**
 * Build internal auth route with MCP flow ID preserved if present
 */
const buildAuthRoute = (path: string): string => {
  const mcpFlowId = getMcpFlowId()
  if (mcpFlowId) {
    return `${path}?mcp_flow_id=${encodeURIComponent(mcpFlowId)}`
  }
  return path
}

const signupUrl = computed(() => buildAuthRoute('/signup'))
const loginUrl = computed(() => buildAuthRoute('/login'))

</script>

<style scoped>
.auth-buttons {
  display: flex;
  align-items: center;
  gap: 16px;
}

.auth-link {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: white;
  text-decoration: none;
  transition: opacity 0.2s;
}

.auth-link:hover {
  opacity: 0.8;
}
</style>